import { Backend } from 'src/infrastructure/createBackend';
import { createContext } from 'react';

type AppContextProps = {
  backend: Backend;
};

const AppContext = createContext<Partial<AppContextProps>>({});

export default AppContext;
